import React from 'react';
import { useFormContext } from 'react-hook-form';

import { S3_BUCKET_URL } from '@/constants';
import { useOnboarding } from '@/pages/Onboarding/context';
import { BODY_SHAPE_OPTIONS } from '@/pages/Onboarding/options/BodyShape/BODY_SHAPE_OPTIONS';
import { ETHNICITY_FEMALE_OPTIONS } from '@/pages/Onboarding/options/EthnicityFemale/ETHNICITY_FEMALE_OPTIONS';
import { HAIR_COLOR_OPTIONS } from '@/pages/Onboarding/options/HairColor/HAIR_COLOR_OPTIONS';
import { preloadImage } from '@/utils/preloadImage';

import { layoutStepsKeys } from '../constants';
import { LayoutDataType } from '../types';

export const usePreloadImages = () => {
  const { wizard } = useOnboarding();
  const currentStepIndex = wizard.stepIndex();
  const currentStep = layoutStepsKeys[currentStepIndex];

  const form = useFormContext<LayoutDataType>();
  const gender = form?.watch('gender');

  React.useEffect(() => {
    if (currentStep === 'gender') {
      preloadImage(`${S3_BUCKET_URL}/layout-own-ai-man/age/sprite-18-24.png`);
      preloadImage(`${S3_BUCKET_URL}/layout-own-ai-man/age/sprite-25-34.png`);
      preloadImage(`${S3_BUCKET_URL}/layout-own-ai-man/age/sprite-35-49.png`);
      preloadImage(`${S3_BUCKET_URL}/layout-own-ai-man/age/sprite-50_plus.png`);

      preloadImage(`${S3_BUCKET_URL}/layout-own-ai/age/sprite-18-24.png`);
      preloadImage(`${S3_BUCKET_URL}/layout-own-ai/age/sprite-25-34.png`);
      preloadImage(`${S3_BUCKET_URL}/layout-own-ai/age/sprite-35-49.png`);
      preloadImage(`${S3_BUCKET_URL}/layout-own-ai/age/sprite-50_plus.png`);
    }

    if (currentStep === 'age') {
      if (gender === 'male') {
        preloadImage(
          `${S3_BUCKET_URL}/layout-own-ai-man/ethnicity/sprite-18-24-african.png`,
        );
        preloadImage(
          `${S3_BUCKET_URL}/layout-own-ai-man/ethnicity/sprite-18-24-asian.png`,
        );
        preloadImage(
          `${S3_BUCKET_URL}/layout-own-ai-man/ethnicity/sprite-18-24-european.png`,
        );
        preloadImage(
          `${S3_BUCKET_URL}/layout-own-ai-man/ethnicity/sprite-18-24-latino.png`,
        );
      } else if (gender === 'female') {
        ETHNICITY_FEMALE_OPTIONS.forEach((option) => {
          preloadImage(
            `${S3_BUCKET_URL}/layout-own-ai/ethnicity/${option.id}/sprite-18-24.png`,
          );
          preloadImage(
            `${S3_BUCKET_URL}/layout-own-ai/ethnicity/${option.id}/sprite-25-34.png`,
          );
          preloadImage(
            `${S3_BUCKET_URL}/layout-own-ai/ethnicity/${option.id}/sprite-35-49.png`,
          );
          preloadImage(
            `${S3_BUCKET_URL}/layout-own-ai/ethnicity/${option.id}/sprite-50_plus.png`,
          );
        });
      }
    }

    if (currentStep === 'hair_color') {
      if (gender === 'female') {
        BODY_SHAPE_OPTIONS.forEach((option) => {
          preloadImage(
            `${S3_BUCKET_URL}/layout-own-ai/body_shape/${option.id}.png`,
          );
        });
      }
    }

    if (currentStep === 'ethnicity') {
      if (gender === 'male') {
        preloadImage(
          `${S3_BUCKET_URL}/layout-own-ai-man/body_shape/skinny.png`,
        );
        preloadImage(
          `${S3_BUCKET_URL}/layout-own-ai-man/body_shape/regular.png`,
        );
        preloadImage(
          `${S3_BUCKET_URL}/layout-own-ai-man/body_shape/athletic.png`,
        );
        preloadImage(
          `${S3_BUCKET_URL}/layout-own-ai-man/body_shape/plus_size.png`,
        );
      } else if (gender === 'female') {
        HAIR_COLOR_OPTIONS.forEach((option) => {
          preloadImage(
            `${S3_BUCKET_URL}/layout-own-ai/hair_color/${option.id}.png`,
          );
        });
      }
    }
  }, [currentStep, gender]);
};
